import { useEffect, useState } from 'react';

export const useHandleOnHoverOnce = (callback: () => void) => {
  const [hasHovered, setHasHovered] = useState(false);
  useEffect(() => {
    if (hasHovered) {
      callback();
    }
  }, [hasHovered, callback]);
  return { handleOnHover: () => setHasHovered(true) };
};
